import { useEffect, useState } from "react";
import api from "@/lib/api";

export const WX_TEXT = (code) => {
  if (code == null) return "";
  if (code <= 1) return "Fine, light winds";
  if (code <= 3) return "Partly cloudy";
  if (code <= 48) return "Fog";
  if (code <= 67) return "Rain";
  if (code <= 77) return "Snow";
  if (code <= 82) return "Showers";
  return "Storm";
};

// Resolve the browser's coordinates, but only when permission is already granted
// (we never trigger a permission prompt from a dashboard widget).
const browserPosition = () =>
  new Promise((resolve) => {
    if (!navigator.geolocation || !navigator.permissions?.query) return resolve(null);
    navigator.permissions
      .query({ name: "geolocation" })
      .then((p) => {
        if (p.state !== "granted") return resolve(null);
        navigator.geolocation.getCurrentPosition(
          (pos) => resolve({ lat: pos.coords.latitude, lng: pos.coords.longitude }),
          () => resolve(null),
          { timeout: 8000, maximumAge: 600000 }
        );
      })
      .catch(() => resolve(null));
  });

// Real forecast for where the crew actually is: the device location when we
// have it, otherwise the org's own site/billing location from the server.
// Returns { days, place } — never invented values.
export function useSiteForecast(count = 5) {
  const [state, setState] = useState({ days: null, place: null });
  useEffect(() => {
    let alive = true;
    (async () => {
      const pos = await browserPosition();
      try {
        const r = pos
          ? await api.get("/weather/forecast", { params: { lat: pos.lat, lng: pos.lng } })
          : await api.get("/weather/auto-forecast");
        const all = r.data?.days || [];
        if (alive && all.length) setState({ days: all.slice(0, count), place: r.data?.place || null });
      } catch {
        if (!pos) return;
        try {
          const r = await api.get("/weather/auto-forecast");
          const all = r.data?.days || [];
          if (alive && all.length) setState({ days: all.slice(0, count), place: r.data?.place || null });
        } catch { /* no weather available */ }
      }
    })();
    return () => { alive = false; };
  }, [count]);
  return state;
}

export function useForecastDays(count = 5) {
  return useSiteForecast(count).days;
}

export function useTodayWeather() {
  const { days } = useSiteForecast(7);
  if (!days?.length) return null;
  const today = new Date().toISOString().slice(0, 10);
  return days.find((d) => d.date === today) || days[0];
}
